import Vue from 'vue'
import Router from 'vue-router'
import store from './store/'
import jQuery from 'jquery'

import Login from './views/Login'
import Logout from './views/Logout'
import Home from './views/Home.vue'
import Polizas from './views/Polizas/Polizas'
import Poliza from './views/Polizas/Poliza'
import Recibos from './views/Recibos/Recibos'
import Recibo from './views/Recibos/Recibo'
import Siniestro from './views/Siniestros/Siniestro'
import Siniestros from './views/Siniestros/Siniestros'
import NuevoSiniestro from './views/Siniestros/NuevoSiniestro'
import Proyectos from './views/Proyectos/Proyectos'
import Proyecto from './views/Proyectos/Proyecto'
import Emitir from './views/Proyectos/Emitir'
import NuevoProyecto from './views/Proyectos/NuevoProyecto'
import Cliente from './views/Cliente/Cliente'
import TelefonosAsistencia from './views/TelefonosAsistencia'
import Registro from './views/Registro'
import ResetPass from './views/ResetPass'

Vue.use(Router);

function requireAuth(to, from, next) {
  jQuery("#navbarSupportedContent").collapse('hide');
  if (!store.getters.credentials.logged) {
      next({
          path: './login',
          query: {redirect: to.fullPath}
      })
  } else {
      next()
  }
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/yo',
      name: 'yo',
      component: Cliente,
      beforeEnter: requireAuth
    },
    {
      path: '/telefonos-asistencia',
      name: 'telefonosAsistencia',
      component: TelefonosAsistencia,
      beforeEnter: requireAuth
    },
    {
      path: '/proyectos',
      name: 'proyectos',
      component: Proyectos,
      beforeEnter: requireAuth
    },
    {
      path: '/proyectos/nuevo',
      name: 'nuevoProyecto',
      component: NuevoProyecto,
      beforeEnter: requireAuth
    },
    {
      path: '/proyectos/:id',
      name: 'proyecto',
      component: Proyecto,
      beforeEnter: requireAuth
    },
    {
      path: '/proyectos/:proyecto/emitir/:cotizacion',
      name: 'emitir',
      component: Emitir,
      beforeEnter: requireAuth
    },
    {
      path: '/polizas',
      name: 'polizas',
      component: Polizas,
      beforeEnter: requireAuth
    },
    {
      path: '/polizas/:id',
      name: 'poliza',
      component: Poliza,
      beforeEnter: requireAuth
    },
    {
      path: '/recibos',
      name: 'recibos',
      component: Recibos,
      beforeEnter: requireAuth
    },
    {
      path: '/recibos/:id',
      name: 'recibo',
      component: Recibo,
      beforeEnter: requireAuth
    },
    {
      path: '/siniestros',
      name: 'siniestros',
      component: Siniestros,
      beforeEnter: requireAuth
    },
    {
      path: '/siniestros/nuevo/:poliza?',
      name: 'nuevoSiniestro',
      component: NuevoSiniestro,
      beforeEnter: requireAuth
    },
    {
      path: '/siniestros/:id',
      name: 'siniestro',
      component: Siniestro,
      beforeEnter: requireAuth
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/registro',
      name: 'registro',
      component: Registro
    },
    {
      path: '/resetpass',
      name: 'resetpass',
      component: ResetPass
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      beforeEnter: requireAuth
    },
  ]
})